import { GridFilterPanelProps } from '@mui/x-data-grid/components/panel/filterPanel/GridFilterPanel';
import { GridLogicOperator } from '@mui/x-data-grid-premium';

const isOnlyUppercase = (str: string) => /^[A-Z]+$/.test(str);

/**
 * Converts an input into a lowercase slug (HelloWorld -> hello-world)
 *
 * For more flexibility this function can handle camelCaseStringInputs
 * as well as PascalCaseStringInputs, "Space Separated Inputs", and "ALLUPPERCASE"
 */
export const paramToSlug = (param: string) => {
	let finalStr = [];
	if (param.includes(' ')) {
		// handles "Space Separated String Inputs"
		finalStr = param.split(' ');
	} else if (isOnlyUppercase(param)) {
		// handles "ALLUPPERCASE" string inputs
		finalStr = [param.toLowerCase()];
	} else {
		// handles PascalCaseStringInputs and camelCaseStringInputs
		finalStr = param.split(/(?=[A-Z0-9])/);
	}

	return finalStr.join('-').toLowerCase();
};

export const datagridFilterPanelAttributes: GridFilterPanelProps = {
	filterFormProps: {
		operatorInputProps: {
			'data-cy': 'datagrid-filter-operator',
		},
		columnInputProps: {
			'data-cy': 'datagrid-filter-column',
		},
		valueInputProps: {
			'data-cy': 'datagrid-filter-value',
		},
		deleteIconProps: {
			'data-cy': 'datagrid-filter-delete',
		},
	},
	logicOperators: [GridLogicOperator.And],
};
